import { render } from "./mainContent.vue?vue&type=template&id=62c437ff"
import script from "./mainContent.vue?vue&type=script&lang=js"
export * from "./mainContent.vue?vue&type=script&lang=js"

import "./mainContent.vue?vue&type=style&index=0&id=62c437ff&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__